import {useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import PageLoader from '../../components/pageLoader';
import useGetListLoanRequest from '../../services/hookService/getListLoanRequest/useGetListLoanRequest';
import {navigateToStep, useIsLoanInStep} from './helpers/navigateToStep';

const LoanStatusWrapper = () => {
  const navigate = useNavigate();

  const {
    data: listLoanRequest,
    isFetching,
    isLoading,
  } = useGetListLoanRequest({
    is_finished: false,
  });

  const isLoanInStep = useIsLoanInStep(listLoanRequest);

  useEffect(() => {
    if (isLoading || !listLoanRequest?.guid) return;

    const nextRoute = navigateToStep(listLoanRequest);

    if (!nextRoute || isLoanInStep) return;

    navigate(nextRoute, {replace: true});
  }, [isLoading, isLoanInStep, listLoanRequest, navigate]);

  if (isFetching) return <PageLoader />;

  return <Outlet />;
};

export default LoanStatusWrapper;
